import ImportLoads from "./ImportLoads";

export default ImportLoads;